import { render, staticRenderFns } from "./LOA.vue?vue&type=template&id=04a62fd4&scoped=true"
import script from "./LOA.vue?vue&type=script&lang=js"
export * from "./LOA.vue?vue&type=script&lang=js"
import style0 from "./LOA.vue?vue&type=style&index=0&id=04a62fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a62fd4",
  null
  
)

export default component.exports